<template>
    <b-form-group>
        <template v-if="!isTimeout">
            <b-skeleton height="76px" width="370px" v-show="loading" />
            <div id="v2-reset-password"></div>
        </template>
        <template v-else>
            <b-alert show variant="danger" class="error mb-0">
                <span>{{ $t('timeout') }}</span>
            </b-alert>
        </template>
    </b-form-group>
</template>

<script>
import { grecaptcha_v2 as captcha } from '@/addons'

export default {
    name: 'Captcha',
    data() {
        return {
            loading: true,
            isTimeout: false,
        }
    },
    async created() {
        try {
            const grecaptcha = await captcha
            grecaptcha.render('v2-reset-password', {
                sitekey: process.env.VUE_APP_CAPTCHA_V2_RESET_PASSWORD,
            })
            this.$emit('ready', true)
            this.$emit('captcha', grecaptcha)
            this.$emit('token', grecaptcha.getResponse)
        } catch (e) {
            this.$emit('ready', false)
            this.isTimeout = true
        } finally {
            this.loading = false
        }
    },
    i18n: {
        messages: {
            'pt-BR': {
                timeout:
                    'Tivemos um problema para carregar as informações da página. Por favor, tente novamente em alguns instantes.',
            },
            'en-US': {
                timeout: 'We had a problem loading the page information. Please try again in a few moments.',
            },
            'es-ES': {
                timeout:
                    'Tuvimos un problema al cargar la información de la página. Inténtelo de nuevo en unos momentos.',
            },
        },
    },
}
</script>

<style lang="scss" scoped>
.captcha-timeout {
    margin: 0;
    color: #dc3545;
    text-align: justify;
    font-family: inherit;
    font-weight: inherit;
    font-size: inherit;
}
</style>
